import {
  Box,
  Button,
  Flex,
  Heading,
  Menu,
  MenuButton,
  MenuList,
} from '@chakra-ui/react';
import { useState } from 'react';
import { BsThreeDots } from 'react-icons/bs';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { Contract } from 'shared/models/contract';
import ContractStatusBadge from '../atoms/ContractStatusBadge/ContractStatusBadge';
import DeleteContractMenuItem from '../atoms/DeleteContractMenuItem';
import ToggleContractStatusMenuItem from '../atoms/ToggleContractStatusMenuItem';
import ManagedAccountModalContext from '../modals/ManagedAccountModal/ModalContext';

interface ContractDetailsPageHeaderProps {
  loading?: boolean;
  contract: Contract;
  onBack?: () => void;
}
const ContractDetailsPageHeader = ({
  loading,
  contract,
  onBack,
}: ContractDetailsPageHeaderProps) => {
  const [isManagedAccountModalOpen, setIsManagedAccountModalOpen] =
    useState(false);

  return (
    <>
      <Flex align="center" gap="3">
        <Button
          variant="regularIcon"
          size="small"
          onClick={() => (onBack ? onBack() : null)}
        >
          <FaArrowLeftLong />
        </Button>
        <Heading opacity={loading ? '.3' : ''} variant="small">
          Detalhes do contrato
        </Heading>

        <Box>
          <ContractStatusBadge
            loading={loading}
            contract={contract}
          ></ContractStatusBadge>
        </Box>
      </Flex>
      <Flex align="center" gap="3">
        <Menu variant="actions">
          <MenuButton
            as={Button}
            isDisabled={loading}
            size="medium"
            leftIcon={<BsThreeDots />}
            variant="regular"
            color="yPrimary.600"
          >
            Ações
          </MenuButton>
          <MenuList>
            <ToggleContractStatusMenuItem contract={contract} />
            <DeleteContractMenuItem />
          </MenuList>
        </Menu>
        <Button
          isDisabled={loading}
          size="medium"
          variant="emphasisPrimary"
          onClick={() => setIsManagedAccountModalOpen(true)}
        >
          Contas gerenciáveis
        </Button>
      </Flex>

      <ManagedAccountModalContext
        isOpen={isManagedAccountModalOpen}
        onClose={() => setIsManagedAccountModalOpen(false)}
        contract={contract}
      />
    </>
  );
};
export default ContractDetailsPageHeader;
